import clsx from 'clsx';
import { CSSProperties, useMemo } from 'react';
import { Check } from 'react-feather';

import style from './RoundCheck.module.css';

export interface RoundCheckProps {
  color: string;
  size?: number;
  showCheck?: boolean;
}

export const RoundCheck = ({ size, color, showCheck }: RoundCheckProps) => {
  const theSize = useMemo(() => size ?? 24, [size]);
  return (
    <div className={clsx(style.root)} style={{ '--size': `${theSize}px`, '--round-check-color': color } as CSSProperties}>
      {showCheck ? <Check color="white" size={theSize - 6} strokeWidth={3} /> : null}
    </div>
  );
};
